import { APP_MAIN_URL } from '../saas/AppStorageStaticNames';
import { APP_LOGGEDIN_AGENTID } from '../shared/constants/Constants';
import { getStringFromLS } from '../shared/helper-utils/localStorage';
import { doPost } from './apiUtils';

export const searchFlightsApi = async (req, signal) => {
  const xmlOrJson = `<flightsearchrequest><credentials><username>APIUSER</username><password>APIUSER</password><officeid>SUPER</officeid></credentials><origin>${req.origin}</origin><destination>${req.destination}</destination><onwarddate>${req.onwarddate}</onwarddate><returndate>${req.returndate}</returndate><numadults>${req.numadults}</numadults><numchildren>${req.numchildren}</numchildren><numinfants>${req.numinfants}</numinfants><journeytype>${req.journeytype}</journeytype><prefclass>${req.prefclass}</prefclass><requestformat>JSON</requestformat><resultformat>JSON</resultformat><searchtype>${req.searchtype}</searchtype><sortkey></sortkey><issbt>false</issbt><profileid></profileid><numresults>100</numresults><actionname>FLIGHTSEARCH</actionname><preddeptimewindow>null</preddeptimewindow><prefarrtimewindow>null</prefarrtimewindow><prefcarrier>${req.prefcarrier}</prefcarrier><prefcarrierall>${req?.prefcarrierall}</prefcarrierall><excludecarriers/><refundtype>All</refundtype><layovertime></layovertime><promocode>${req.promocode}</promocode></flightsearchrequest>`;
  const request = {
    opid: 'FS000',
    actioncode: 'FSAPIV4',
    agentid: 'SUPER',
    xmlorjson: xmlOrJson,
  };
  const response = await doPost(request, signal);
  return response?.flightsearchresponse
    ? response.flightsearchresponse
    : undefined;
};

export const updateGstDetails = async (reqObj) => {
  try {
    const req = {
      opid: 'PROFILE001',
      actioncode: 'UPDATEAGENTWISEGSTDETAILS',
      resultformat: 'JSON',
      ...reqObj,
    };

    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getRecentAirports = async (companyName) => {
  // const request = {
  //   opid: 'FS000',
  //   actioncode: 'POPULARSECTOR',
  // };
  // const response = await doPost(request);
  if (companyName && companyName.toLowerCase() === 'sanram travels') {
    return {
      ApiStatus: {
        Status: 'OK',
        Result: {
          AirportDetail: [
            {
              AirportCode: 'DXB',
              AirportLocation: 'Dubai, United Arab Emirates',
              AirportName: 'Dubai International',
              Country: 'United Arab Emirates',
              CountryCode: 'AE',
              Lat: 25.252778,
              Lng: 55.364444,
            },
            {
              AirportCode: 'LHR',
              AirportLocation: 'London, UK',
              AirportName: 'Heathrow Airport',
              Country: 'United Kingdom',
              CountryCode: 'GB',
              Lat: 51.4775,
              Lng: -0.461389,
            },
            {
              AirportCode: 'SYD',
              AirportLocation: 'Sydney, Australia',
              AirportName: 'Kingsford Smith',
              Country: 'Australia',
              CountryCode: 'AU',
              Lat: -33.946111,
              Lng: 151.177222,
            },
            {
              AirportCode: 'YTO',
              AirportLocation: 'Toronto, ON, Canada',
              AirportName: 'All airports',
              Country: 'Canada',
              CountryCode: 'CA',
              Lat: 43.653056,
              Lng: -79.383056,
            },
          ],
        },
      },
    };
  }

  return {
    ApiStatus: {
      Status: 'OK',
      Result: {
        AirportDetail: [
          {
            AirportCode: 'DEL',
            AirportLocation: 'New Delhi, India',
            AirportName: 'Indira Gandhi Intl',
            Country: 'India',
            CountryCode: 'IN',
            Lat: 28.5665,
            Lng: 77.103088,
          },
          {
            AirportCode: 'BOM',
            Lng: 72.867919,
            AirportName: 'Chhatrapati Shivaji',
            Country: 'India',
            AirportLocation: 'Mumbai, Bombay, India',
            CountryCode: 'IN',
            Lat: 19.088686,
          },
          {
            AirportCode: 'AMD',
            Lng: 72.63465,
            AirportName: 'Ahmedabad',
            Country: 'India',
            AirportLocation: 'Ahmedabad, India',
            CountryCode: 'IN',
            Lat: 23.077242,
          },
          {
            AirportCode: 'BLR',
            Lng: 77.668206,
            AirportName: 'Bengaluru Intl',
            Country: 'India',
            AirportLocation: 'Bengaluru, Bangalore, India',
            CountryCode: 'IN',
            Lat: 12.949986,
          },
          {
            AirportCode: 'COK',
            Lng: 76.391389,
            AirportName: 'Kochi',
            Country: 'India',
            AirportLocation: 'Kochi, Cochin, India',
            CountryCode: 'IN',
            Lat: 10.155556,
          },
        ],
      },
    },
  };
};

export const paxWiseRescheduleSearchFlightsApi = async (
  paxDetailsArr,
  searchParam,
  agentId,
  transactionId,
  rescheduleType,
) => {
  const request = {
    opid: 'PERFORMRESCHEDULEV4',
    actioncode: 'RESCHEDULESEARCHV4',
    reschedulesearchjson: JSON.stringify({
      reschedulesearch: {
        paxdetails: paxDetailsArr,
        searchparams: searchParam,
        agentid: agentId,
        txid: transactionId,
        rescheduletype: rescheduleType,
      },
    }),
  };
  const response = await doPost(request);
  return response.flightsearchresponse
    ? response.flightsearchresponse
    : undefined;
};

export const rescheduleSearchFlightsApi = async (
  paxDetailsArr,
  searchParam,
  agentId,
  transactionId,
  rescheduleType,
) => {
  const request = {
    opid: 'PERFORMRESCHEDULEV4',
    actioncode: 'RESCHEDULESEARCHV4',
    reschedulesearchjson: JSON.stringify({
      reschedulesearch: {
        paxdetails: paxDetailsArr,
        searchparams: searchParam,
        agentid: agentId,
        txid: transactionId,
        rescheduletype: rescheduleType,
      },
    }),
  };
  const response = await doPost(request);
  return response.flightsearchresponse
    ? response.flightsearchresponse
    : undefined;
};

export const getAirportsApi = async (searchKey) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'SEARCHAIR',
      searchkey: searchKey,
    };
    let response = await doPost(request);
    response = Array.isArray(response.Root.Result.AirportDetail)
      ? response.Root.Result.AirportDetail
      : [response.Root.Result.AirportDetail];
    return response.filter(
      (airportNode) =>
        airportNode.AirportCode !== '' && airportNode.AirportCode !== 'HDD',
    );
  } catch (error) {
    return [];
  }
};

export const validateFlightPriceApi = async (
  agentId,
  tripType,
  cachekeyOnward,
  cachekeyReturn,
) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'FSTAXESV4',
      resultformat: 'jsonv2',
      agentid: agentId,
      triptype: tripType.toLowerCase(),
      cachekeyow: cachekeyOnward,
    };
    if (tripType.toLowerCase() === 'roundtrip') {
      request.cachekeytw = cachekeyReturn;
    }
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const validateInternationalFlightPriceApi = async (
  agentId,
  tripType,
  cachekey,
) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'FSTAXESINTLV4',
      agentid: agentId,
      triptype: tripType,
      cachekey,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const validateRescheduleFlightPriceApi = async (
  agentId,
  transactionId,
  tripType,
  cachekeyOnward,
  cachekeyReturn,
) => {
  try {
    const request = {
      opid: 'PERFORMRESCHEDULEV4',
      actioncode: 'RESCHEDULETAXESV4',
      resultformat: 'JSON',
      txid: transactionId,
      agentid: agentId,
      triptype: tripType.toLowerCase(),
      cachekeyow: cachekeyOnward,
    };
    if (tripType.toLowerCase() === 'roundtrip') {
      request.cachekeytw = cachekeyReturn;
    }
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getSeatLayoutApiTemp = async () => {
  const response = await fetch(
    'http://localhost:9090/https://template12.iweensoft.com/seatlayoutresponsev4.json',
  );
  const resp = await response.json();
  return resp;
};

export const getSeatLayoutApi = async (
  agentId,
  tripType,
  selectedFlightKey,
  domint,
) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETSEATLAYOUTV4',
      agentid: agentId,
      triptype: tripType,
      selectedflight: selectedFlightKey,
      resultformat: 'JSON',
      domint,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getSSRApi = async (selectedFlightKey, tripType) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETSSRV4',
      selectedflight: selectedFlightKey,
      triptype: tripType,
    };
    const response = await doPost(request);
    return response.ApiStatus.Result !== null
      ? response.ApiStatus.Result
      : undefined;
  } catch (error) {
    return undefined;
  }
};

export const bookFlightApi = async (request, agentId, actioncode, opid) => {
  try {
    const bookingRequest = {
      opid,
      actioncode,
      agentid: agentId,
      bookedbyid: getStringFromLS(APP_LOGGEDIN_AGENTID),
      flightbookingjson: JSON.stringify(request),
    };
    const response = await doPost(bookingRequest);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const HoldFlightApi = async (request, agentId, actioncode) => {
  try {
    const bookingRequest = {
      opid: 'TX005',
      actioncode,
      agentid: agentId,
      bookedbyid: getStringFromLS(APP_LOGGEDIN_AGENTID),
      flightbookingjson: JSON.stringify(request),
    };
    const response = await doPost(bookingRequest);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const rescheduleBookFlightApi = async (request, agentId, tripType) => {
  try {
    const bookingRequest = {
      opid: 'PERFORMRESCHEDULEV4',
      actioncode: 'PERFORMFLIGHTRESCHEDULEV4',
      agentid: agentId,
      triptype: tripType,
      resultformat: 'JSON',
      flightreschedulejson: JSON.stringify(request),
    };
    const response = await doPost(bookingRequest);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightTicketApi = async (transactionId, agentId) => {
  try {
    const request = {
      opid: 'RQ000',
      txid: transactionId,
      agentid: agentId,
      actioncode: 'RQ001',
      resultformat: 'json',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBookingsApi = async (fromDate, toDate, agentId) => {
  try {
    const request = {
      agentid: agentId,
      opid: 'RP023',
      actioncode: 'FLIGHTHISTORYV5',
      fromdate: fromDate,
      todate: toDate,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    if (response.Root.Status === 'OK') {
      const { FlightSectorRecord } = response.Root.Result;
      return Array.isArray(FlightSectorRecord)
        ? FlightSectorRecord
        : [FlightSectorRecord];
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getUpCompingBookings = async (agentId) => {
  try {
    const request = {
      agentid: agentId,
      opid: 'RP023',
      actioncode: 'GETUPCOMINGBOOKINGS',
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    if (response.Root.Status === 'OK') {
      const { FlightSectorRecord } = response.Root.Result;
      return Array.isArray(FlightSectorRecord)
        ? FlightSectorRecord
        : [FlightSectorRecord];
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getCancellationPolicyApi = async (agentId, transactionId) => {
  try {
    const request = {
      agentid: agentId,
      opid: 'FS000',
      actioncode: 'GETCANCELLATIONPOLICY',
      resultformat: 'JSON',
      canxpolicyjson: JSON.stringify({
        farerulerequest: {
          txid: transactionId,
        },
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return [];
  }
};

export const cancelFlightBookingApi = async (
  agentId,
  transactionId,
  cancellationType,
  paxDetailsArr,
  remarks,
  requestername,
  contactnumber,
) => {
  try {
    const request = {
      opid: 'PERFORMCANCELV5',
      flightcanceljson: JSON.stringify({
        cancelrequest: {
          paxdetails: paxDetailsArr,
          agentid: agentId,
          txid: transactionId,
          canxtype: cancellationType,
          remarks,
          requestername,
          contactnumber,
        },
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return [];
  }
};

export const getPostBookingSsrApi = async (txId, tripType) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETSSRPOSTBOOKINGV5',
      txid: txId,
      triptype: tripType,
      responseformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getPostBookingSeatLayoutApi = async (txId, tripType) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETSEATLAYOUTPOSTBOOKINGV4',
      txid: txId,
      triptype: tripType,
      responseformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const performPostBookingSsr = async (txId, ssrList) => {
  try {
    const request = {
      opid: 'TX004',
      actioncode: 'PERFORMPOSTBOKINGSSR',
      postbookingaddssrrequest: JSON.stringify({
        txid: txId,
        ssrlist: {
          list: {
            SSRRow: ssrList,
          },
        },
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getCancelRefundApi = async (txId, tripType) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETREFUNDAMOUNTV5',
      triptype: tripType,
      txid: txId,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFareRulesApi = async (onwardFareKey, returnFareKey, domInt) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETFARERULES',
      agentid: 'SUPER',
      farerulejson: JSON.stringify({
        farerulerequest: {
          selectedflight: onwardFareKey,
          selectedflight_return: returnFareKey,
          domint: domInt,
        },
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightPaxCalendarApi = async (agentid, calmonth, calyear) => {
  try {
    const request = {
      agentid,
      resultformat: 'JSON',
      opid: 'RP006',
      actioncode: 'PAXCAL',
      calmonth,
      calyear,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightHoldQueuesApi = async (agentid) => {
  try {
    const request = {
      agentid,
      opid: 'MQ021',
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightResheduleDetailsApi = async (txId, agentId) => {
  try {
    const request = {
      opid: 'MQ000',
      resultformat: 'MQ007',
      agentid: agentId,
      txid: txId,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightCancellationsApi = async (fromDate, toDate, agentId) => {
  try {
    const request = {
      agentid: agentId,
      opid: 'RP002',
      fromdate: fromDate,
      todate: toDate,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightReshedulesApi = async (fromDate, toDate, agentId) => {
  try {
    const request = {
      agentid: agentId,
      opid: 'RP006',
      actioncode: 'RESCHISTORY',
      fromdate: fromDate,
      todate: toDate,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightHoldQueuesListApi = async (fromDate, toDate, agentId) => {
  try {
    const request = {
      agentid: agentId,
      opid: 'RP006',
      actioncode: 'GETHOLDHISTORY',
      fromdate: fromDate,
      todate: toDate,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightInvoiceDetailsApi = async (txId, agentId) => {
  try {
    const request = {
      opid: 'MQ000',
      txid: txId,
      agentid: agentId,
      actioncode: 'MQ007',
      resultformat: 'JSONV2',
    };
    const response = await doPost(request);
    if (response.Root.Status === 'OK') {
      return response.Root.Result;
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
};

export const emailFlightOptions = async (
  fromEmail,
  fromName,
  toEmail,
  htmlContent,
  mailSubject,
) => {
  try {
    const encodedHtmlContent = btoa(unescape(encodeURIComponent(htmlContent)));
    const request = {
      opid: 'EM001',
      toemail: toEmail,
      htmlcontent: encodedHtmlContent,
      fromemail: fromEmail,
      fromname: fromName,
      subject: mailSubject || 'Your Flight Booking Details',
      resultformat: 'JSON',
      isenc: 'true',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const addMarkupInTicket = async (agentid, txid, markupamount) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'FS007',
      resultformat: 'JSON',
      agentid,
      txid,
      markupamount,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const addBaggageInTicket = async (agentid, txid, additionalssr) => {
  try {
    const request = {
      opid: 'GENERIC000',
      actioncode: 'ADDSSRTICKETCOPY',
      resultformat: 'JSON',
      agentid,
      txid,
      additionalssr,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const showInPdf = async (agentid, htmlcontent, txid) => {
  try {
    const API_PATH = getStringFromLS(APP_MAIN_URL);
    const encodedHtmlContent = btoa(unescape(encodeURIComponent(htmlcontent)));
    const request = {
      opid: 'GENERIC',
      actioncode: 'SHOWGENERICPDF',
      filetype: 'flightticket',
      resultformat: 'JSON',
      domainname: API_PATH,
      agentid,
      htmlcontent: encodedHtmlContent,
      txid,
      isenc: 'true',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightCancellationDetailsApi = async (txId, agentId) => {
  try {
    const request = {
      opid: 'MQ000',
      txid: txId,
      agentid: agentId,
      actioncode: 'MQ008',
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    // if (response.Root.Status === 'OK') {
    //   return response.Root.Result;
    // }
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBrandedFaresApi = async (
  req,
  flightKey,
  agentid,
  triptype,
  domint,
  signal,
) => {
  const xmlOrJson = `<flightsearchrequest><credentials><username>APIUSER</username><password>APIUSER</password><officeid>SUPER</officeid></credentials><origin>${req.origin}</origin><destination>${req.destination}</destination><onwarddate>${req.onwarddate}</onwarddate><returndate>${req.returndate}</returndate><numadults>${req.numadults}</numadults><numchildren>${req.numchildren}</numchildren><numinfants>${req.numinfants}</numinfants><journeytype>${req.journeytype}</journeytype><prefclass>${req.prefclass}</prefclass><requestformat>JSON</requestformat><resultformat>JSON</resultformat><searchtype>${req.searchtype}</searchtype><sortkey></sortkey><issbt>false</issbt><profileid></profileid><numresults>100</numresults><actionname>FLIGHTSEARCH</actionname><preddeptimewindow>null</preddeptimewindow><prefarrtimewindow>null</prefarrtimewindow><prefcarrier>${req.prefcarrier}</prefcarrier><excludecarriers/><refundtype>All</refundtype><layovertime></layovertime><promocode>${req.promocode}</promocode></flightsearchrequest>`;
  const request = {
    opid: 'FS000',
    actioncode: 'GETMOREFARESV4',
    cachekeyow: flightKey,
    xmlorjson: xmlOrJson,
    agentid,
    domint,
    triptype,
    resultformat: 'json',
  };
  const response = await doPost(request, signal);
  return response.flightsearchresponse
    ? response.flightsearchresponse
    : undefined;
};

export const getClassAvailability = async (key, domInt) => {
  try {
    const req = {
      opid: 'FS000',
      actioncode: 'GETAVAILCLASSESV4',
      cachekey: key,
      domint: domInt,
      resultformat: 'json',
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getClassAvailabilityFare = async (
  key,
  domInt,
  selectedClasses,
  tripType,
) => {
  try {
    const req = {
      opid: 'FS000',
      actioncode: 'GETFAREFORSELECTEDCLASS',
      cachekey: key,
      domint: domInt,
      triptype: tripType,
      resultformat: 'json',
      selectedclasses: JSON.stringify({
        selectedclasses: selectedClasses,
      }),
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getClassAvailabilityFareForRoundtrip = async (
  key,
  keyrt,
  domInt,
  selectedClasses,
) => {
  try {
    const req = {
      opid: 'FS000',
      actioncode: 'GETFAREFORSELECTEDCLASSRT',
      cachekey: key,
      cachekey_return: keyrt,
      domint: domInt,
      resultformat: 'json',
      selectedclasses: JSON.stringify({
        selectedclasses: selectedClasses,
      }),
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const performSplitPnr = async (paxList, txId) => {
  try {
    const req = {
      opid: 'TX004',
      actioncode: 'PERFORMDIVIDEPNR',
      resultformat: 'json',
      txid: txId,
      dividepaxlist: JSON.stringify({
        paxdetails: paxList,
      }),
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const performticketing = async (txId) => {
  try {
    const req = {
      opid: 'TX006',
      txid: txId,
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getMiniFareRulesApi = async (
  onwardFareKey,
  returnFareKey,
  domInt,
) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETMINIFARERULES',
      agentid: 'SUPER',
      farerulejson: JSON.stringify({
        farerulerequest: {
          selectedflight: onwardFareKey,
          selectedflight_return: returnFareKey,
          domint: domInt,
        },
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const performWebCheckInApi = async (
  pnr,
  seatpref,
  seatnumber,
  emailid,
  triptype,
) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'PERFORMWEBCHECKIN',
      pnr,
      seatpref,
      seatnumber,
      emailid,
      triptype,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const offlineCancelRequestApi = async (
  agentId,
  transactionId,
  cancellationType,
  paxDetailsArr,
  remarks,
  requestername,
  contactnumber,
) => {
  try {
    const request = {
      opid: 'PERFORMCANCELV5',
      actioncode: 'RAISECANCELLATIONREQUEST',
      flightcanceljson: JSON.stringify({
        cancelrequest: {
          paxdetails: paxDetailsArr,
          agentid: agentId,
          txid: transactionId,
          canxtype: cancellationType,
          remarks,
          requestername,
          contactnumber,
        },
      }),
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return [];
  }
};

export const getPassThroughInfo = async (domint, cachekeyow) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETPASSTHROUGHSETTINGSV4',
      domint,
      cachekeyow,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const releaseTicketApi = async (txid) => {
  try {
    const request = {
      opid: 'PERFORMCANCELV5',
      actioncode: 'PERFORMHOLDRELEASEV5',
      txid,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const importPnrApi = async (pnr, domint, gdsname) => {
  try {
    const request = {
      opid: 'TX004',
      actioncode: 'GDSIMPORTPNR',
      resultformat: 'JSON',
      pnr,
      domint,
      gdsname,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const chooseCustomerApi = async (profileName, agentId) => {
  try {
    const request = {
      opid: 'PROFILE003',
      actioncode: 'GETPROFILEFORNAME',
      resultformat: 'JSON',
      corporateid: agentId,
      name: profileName,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const savePaxDetailsApi = async (req, agentId) => {
  try {
    const request = {
      opid: 'PROFILE001',
      actioncode: 'ADDTRAVELLERPROFILE',
      resultformat: 'JSON',
      corporateid: agentId,
      ...req,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getAllPersonalTravellersForAgentIdApi = async (
  agentid,
  mobilenumber,
) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETALLPERSONALTRAVELLERS',
      resultformat: 'JSON',
      agentid,
      mobilenumber,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getSearchResultsForMulticity = async (req, signal) => {
  const xmlOrJson = `<flightsearchrequest><credentials><username>APIUSER</username><password>APIUSER</password><officeid>SUPER</officeid></credentials><origin>${req.origin}</origin><destination>${req.destination}</destination><onwarddate>${req.onwarddate}</onwarddate><returndate>${req.returndate}</returndate><numadults>${req.numadults}</numadults><numchildren>${req.numchildren}</numchildren><numinfants>${req.numinfants}</numinfants><journeytype>${req.journeytype}</journeytype><prefclass>${req.prefclass}</prefclass><requestformat>JSON</requestformat><resultformat>JSON</resultformat><searchtype>${req.searchtype}</searchtype><sortkey></sortkey><issbt>false</issbt><profileid></profileid><numresults>100</numresults><actionname>FLIGHTSEARCH</actionname><preddeptimewindow>null</preddeptimewindow><prefarrtimewindow>null</prefarrtimewindow><prefcarrier>${req.prefcarrier}</prefcarrier><excludecarriers/><refundtype>All</refundtype><layovertime></layovertime><promocode>${req.promocode}</promocode></flightsearchrequest>`;
  const request = {
    opid: 'FS000',
    actioncode: 'FSMULTICITYSEARCHV4',
    agentid: req.agentid,
    xmlorjson: xmlOrJson,
  };
  const response = await doPost(request, signal);
  return response.flightsearchresponse
    ? response.flightsearchresponse
    : undefined;
};

export const validateMultiCityFlightPriceApi = async (tripType, cachekey) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'FSMULTICITYTAXES',
      domint: tripType,
      selectedflight: cachekey,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getPaymentGateway = async (agentId) => {
  try {
    const request = {
      opid: 'PAYMENTGATEWAY',
      actioncode: 'GETAVAILABLEPG',
      resultformat: 'JSON',
      agentid: agentId,
      version: '2',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFareInclusion = async (domInt) => {
  try {
    const request = {
      opid: 'FS000',
      actioncode:
        domInt === 'international'
          ? 'GETFAREINCLUSIONSINTL'
          : 'GETFAREINCLUSIONS',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getFareInclusionINTL = async () => {
  try {
    const request = {
      opid: 'FS000',
      actioncode: 'GETFAREINCLUSIONSINTL',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getBookingValidations = async (key) => {
  try {
    const req = {
      opid: 'GENERIC',
      actioncode: 'BOOKINGPAGEVALIDATIONS',
      resultformat: 'JSON',
      cachekeyow: key,
    };
    const response = await doPost(req);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const requestRescheduleApi = async (req) => {
  try {
    const request = {
      opid: 'TX018',
      resultformat: 'JSON',
      ...req,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getPGCheckOutAmountApi = async (
  paymentMode,
  selectedPg,
  domint,
  totalAmount,
  flight,
  agentId,
  bankId,
) => {
  try {
    const request = {
      opid: 'PAYMENTGATEWAY',
      actioncode: 'GETPGCHECKOUTAMOUNT',
      resultformat: 'JSON',
      agentid: agentId,
      paymentmode: paymentMode,
      pgname: selectedPg,
      transactiontype: `${flight}${domint}`,
      totalamount: totalAmount,
      bankcode: bankId,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getFlightCancellationsQueuesApi = async (
  fromDate,
  toDate,
  agentId,
) => {
  try {
    const request = {
      agentid: agentId,
      opid: 'MQ021',
      actioncode: 'PENDINGQUEUES',
      queuetype: 'flightcanx',
      fromdate: fromDate,
      todate: toDate,
      resultformat: 'JSON',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const addAgentGSTDetails = async (gst, agentId) => {
  try {
    const request = {
      opid: 'PROFILE001',
      actioncode: 'ADDAGENTWISEGSTDETAILS',
      resultformat: 'json',
      agentid: agentId,
      gstnumber: gst.gstnumber,
      gstemail: gst.gstemail,
      gstcontactnumber: gst.gstphone,
      gstaddress: gst.gstaddress,
      gstcompany: gst.gstcompany,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
export const getAgentGSTList = async (agentid) => {
  try {
    const request = {
      opid: 'PROFILE001',
      actioncode: 'GETAGENTWISEGSTDETAILSLIST',
      agentid,
      resultformat: 'json',
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getCurrentAvailCouponDetailForAgent = async (agentid) => {
  try {
    const request = {
      opid: 'AGENTCOUPON',
      actioncode: 'GETCURRENTAVAILCOUPONDETAILFORAGENT',
      resultformat: 'JSON',
      agentid,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};

export const getFlightSeriesListForSeriesOwner = async (
  fromdate,
  todate,
  agentid,
) => {
  try {
    const request = {
      opid: 'RP006',
      actioncode: 'GETFlLIGHTSERIESTXNFORSERIESOWNER',
      resultformat: 'JSON',
      fromdate,
      todate,
      agentid,
    };
    const response = await doPost(request);
    return response;
  } catch (error) {
    return undefined;
  }
};
